import React from 'react';
import { HiOutlineArrowSmRight } from "react-icons/hi";

const ProjectItems = ({item}) => {
  return (
        <div className="project__card" key={item.id}>
            <img className="project__img" src={item.image} alt="" />
            <h3 className="project__title">{item.title}</h3>

            <div style={{maxWidth:"500px",paddingBottom:"15px"}}>
            {item.description}
            </div>
            <h5 style={{maxWidth:"500px",paddingBottom:"15px"}}>{item.techStack}</h5>
            <div style={{display:"flex", justifyContent:"space-between"}}>
            <a href={item.visit} className="project__button">
                Live <HiOutlineArrowSmRight className="project__button-icon" />
            </a>
            <a href={item.github} className="project__button">
            Github <HiOutlineArrowSmRight className="project__button-icon" />
            </a>
            </div>
           
        </div>
    );
}

export default ProjectItems;